import React from "react";
import styled from "styled-components";
import pic1 from './pic1.jpg';
import pic2 from './pic2.jpg';
import pic3 from './pic3.jpg';
import {Modal} from 'bootstrap'
import {LoginButton} from "../../LoginButton/LoginButton";

const StyledWrapper = styled.div`
  color: ${({theme}) => theme.colorTokens.aliases.text};
  border-radius: ${({theme}) => theme.borderRadius};
`;

export const AlcoLoginPage = ({lang, clientCtx}) => {

    const translations = {
        en: {
            nav: {
                brand: 'Alco Shop',
                products: 'Products',
                contact: 'Contact',
                about: 'About'
            },
            topProducts: {
                title: 'Top products',
                addToCart: 'Add to cart',
                confirmText: 'Please confirm you are over {ageComparator} years old.',
                confirmButton: 'Confirm age'
            }
        },
        et: {
            nav: {
                brand: 'Alco Shop',
                products: 'Tooted',
                contact: 'Kontakt',
                about: 'Meist'
            },
            topProducts: {
                title: 'Parimad tooted',
                addToCart: 'Lisa ostukorvi',
                confirmText: 'Palun kinnita, et oled üle {ageComparator} aastat vana.',
                confirmButton: 'Kinnita vanus'
            }
        },
        lv: {
            nav: {
                brand: 'Alco Shop',
                products: 'Products',
                contact: 'Contact',
                about: 'About'
            },
            topProducts: {
                title: 'Top products',
                addToCart: 'Add to cart',
                confirmText: 'Please confirm you are over {ageComparator} years old.',
                confirmButton: 'Confirm age'
            }
        }
    }

    const product = (src: any, title: string) => {
        return <div className="card" aria-hidden="true">
            <img src={src} alt={title}/>
            <div className="card-body real-product">
                <h5 className="card-title">{title}</h5>
                <p className="card-text">
                    <span>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam eget erat consequat, fringilla tortor id, consectetur orci. Integer imperdiet fermentum.</span>
                </p>
                <button type="button" className="btn btn-primary col-6" onClick={openConfirmationModal}>
                    {translations[lang].topProducts.addToCart}
                </button>
            </div>
        </div>
    }

    const confirmationModal = () => {
        const confirmText = translations[lang].topProducts.confirmText.replace("{ageComparator}", localStorage.getItem('ageComparator'))
        return <div className="modal fade" id="confirmationModal" aria-labelledby="confirmationModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                        {confirmText}
                    </div>
                    <div className="modal-footer">
                        <LoginButton clientCtx={clientCtx} text={translations[lang].topProducts.confirmButton}/>
                    </div>
                </div>
            </div>
        </div>
    }

    const openConfirmationModal = () => {
        const myModal = new Modal(document.getElementById("confirmationModal"), {});
        myModal.show();
    }

    return <StyledWrapper className='alco123'>
        <div className="modal" role="dialog">
            <div className="modal-dialog" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Modal title</h5>
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <p>Modal body text goes here.</p>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" data-dismiss="modal">Close</button>
                        <button type="button" className="btn btn-primary">Save changes</button>
                    </div>
                </div>
            </div>
        </div>
        <header className="header alco123">
            <nav className="nav">
                <img
                    src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMjAgNTEyIj48IS0tISBGb250IEF3ZXNvbWUgUHJvIDYuNC4wIGJ5IEBmb250YXdlc29tZSAtIGh0dHBzOi8vZm9udGF3ZXNvbWUuY29tIExpY2Vuc2UgLSBodHRwczovL2ZvbnRhd2Vzb21lLmNvbS9saWNlbnNlIChDb21tZXJjaWFsIExpY2Vuc2UpIENvcHlyaWdodCAyMDIzIEZvbnRpY29ucywgSW5jLiAtLT48cGF0aCBkPSJNMzIuMSAyOS4zQzMzLjUgMTIuOCA0Ny40IDAgNjQgMEgyNTZjMTYuNiAwIDMwLjUgMTIuOCAzMS45IDI5LjNsMTQgMTY4LjRjNiA3Mi00Mi41IDEzNS4yLTEwOS45IDE1MC42VjQ0OGg0OGMxNy43IDAgMzIgMTQuMyAzMiAzMnMtMTQuMyAzMi0zMiAzMkgxNjAgODBjLTE3LjcgMC0zMi0xNC4zLTMyLTMyczE0LjMtMzIgMzItMzJoNDhWMzQ4LjRDNjAuNiAzMzMgMTIuMSAyNjkuOCAxOC4xIDE5Ny44bDE0LTE2OC40em01NiA5OC43SDIzMS45bC01LjMtNjRIOTMuNGwtNS4zIDY0eiIvPjwvc3ZnPg=="
                    alt="Alco Shop logo"
                    className="nav__logo"
                    id="logo"
                    data-version-number="3.0"
                />
                <ul className="nav__links">
                    <li className="nav__item">
                        <a className="nav__link" href="#">{translations[lang].nav.brand}</a>
                    </li>
                    <li className="nav__item">
                        <a className="nav__link" href="#">{translations[lang].nav.products}</a>
                    </li>
                    <li className="nav__item">
                        <a className="nav__link" href="#">{translations[lang].nav.contact}</a>
                    </li>
                    <li className="nav__item">
                        <a className="nav__link" href="#">{translations[lang].nav.about}</a>
                    </li>
                </ul>
            </nav>
        </header>

        <section className="section">
            <div className="section__title">
                <h2 className="section__description">{translations[lang].topProducts.title}</h2>

                <div className="row">
                    <div className='col-4'>
                        {product(pic1, "Product 1")}
                    </div>
                    <div className='col-4'>
                        {product(pic2, "Product 2")}
                    </div>
                    <div className='col-4'>
                        {product(pic3, "Product 3")}
                    </div>
                </div>
            </div>
        </section>
        {confirmationModal()}

    </StyledWrapper>
}
